module.exports = __webpack_public_path__ + "static/img/btn_aixinjuanzeng_nor.6d0d49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_aixinjuanzeng_nor.png
// module id = Dz8M
// module chunks = 1